import { ExpedientesService } from './../../services/expedientes.service';
import { Component, OnInit, ElementRef, Renderer2, ViewChild  } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
@Component({
  selector: 'app-consulta',
  templateUrl: './consulta.component.html',
  styleUrls: ['./consulta.component.css']
})
export class ConsultaComponent implements OnInit {

  formulario={
    titulo:"",
    fecha:"",
    descripcion:"",
    tipo:"consulta"
  };

  nombreArchivo1;
  nombreArchivo2;
  nombreArchivo3;
  nombreArchivo4;
  nombreArchivo5;

  nombresArchivos;
  archivos;
  
  
  @ViewChild("subirArchivo")  archivoSubido: ElementRef;
  @ViewChild("subirArchivo2") archivoSubido2: ElementRef;
  @ViewChild("subirArchivo3") archivoSubido3: ElementRef;
  @ViewChild("subirArchivo4") archivoSubido4: ElementRef;
  @ViewChild("subirArchivo5") archivoSubido5: ElementRef;

  

  constructor(private router:Router, private auth:AuthService, private expedientesService:ExpedientesService) { }

  ngOnInit() {
    
  }

  irSiguientePantalla(){
    let textoAceptar="A continuación debe realizar el pago correspondiente a su consulta\n\n"
                    +"Una vez efectuado, su consulta será enviada a nuestro departamento jurídico para su tramitación.\n\n"
                    +"Gracias por confiar en SOLUCIONLEGAL";
    if(confirm(textoAceptar)){
      let expediente={
        EXtitulo:this.formulario.titulo,
        EXcodcliente: this.auth.usuarioActivo.CLcodigo,
        EXfechaapertura: this.formulario.fecha,
        EXdescripcion: this.formulario.descripcion,
        EXnombre: this.auth.usuarioActivo.CLnombre,
        EXemail: this.auth.usuarioActivo.CLemail,
        EXtelefono: this.auth.usuarioActivo.CLtelefono,
        EXregistrado:0,
        EXpagado:0
      }

      if(this.formulario.tipo=="consulta"){
        expediente["EXconsulta"]=1;
        this.expedientesService.insertExpedienteConsulta(expediente).subscribe(resp=>{
          
          this.router.navigate(["/consulta","consultalegal"]);
        });
        
      }else if(this.formulario.tipo=="estudio"){
        expediente["EXestudio"]=1;

        this.nombresArchivos=[
          this.nombreArchivo1,
          this.nombreArchivo2,
          this.nombreArchivo3,
          this.nombreArchivo4,
          this.nombreArchivo5
        ];
    
        this.archivos=[
          this.archivoSubido,
          this.archivoSubido2,
          this.archivoSubido3,
          this.archivoSubido4,
          this.archivoSubido5
        ];

        this.expedientesService.insertExpedienteConsulta(expediente).subscribe(resp=>{
        
        for(let i=0;i<this.archivos.length;i++){
          
          if(this.archivos[i] && this.archivos[i].nativeElement.files.length>0){
            
            let adjunto={ EDcodexpediente : resp["id_introducido"],
                          EDdescripcion: this.nombresArchivos[i]};
            
            this.insertarAdjunto(adjunto, this.archivos[i].nativeElement.files[0]);              
          }
        }
        this.router.navigate(["/consulta","estudiolegal"]);
        

        });
      }
    }
  }

  insertarAdjunto(adjunto, archivo){
    
    this.expedientesService.insertAdjunto(adjunto, archivo).subscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/consulta/consulta.component.ts